(function() {
  'use strict';

  const form = document.querySelector('.footer__newsletter-form');
  if (!form) return;

  const input = form.querySelector('.footer__newsletter-input');
  const messageContainer = form.querySelector('.footer__newsletter-message');
  const errorMessage = form.dataset.errorMessage || 'PLEASE ENTER VALID EMAIL';

  if (!input || !messageContainer) return;

  // Function to validate email
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Function to show error message
  function showError() {
    messageContainer.innerHTML = `<span class="footer__newsletter-error caption-large">${errorMessage}</span>`;
    messageContainer.setAttribute('aria-live', 'polite');
  }

  // Function to clear message
  function clearMessage() {
    messageContainer.innerHTML = '';
    messageContainer.removeAttribute('aria-live');
  }

  // Validate on input
  input.addEventListener('input', function() {
    const value = this.value.trim();
    
    if (value.length > 0 && !isValidEmail(value)) {
      showError();
    } else {
      clearMessage();
    }
  });

  // Validate on blur
  input.addEventListener('blur', function() {
    const value = this.value.trim();
    
    if (value.length > 0 && !isValidEmail(value)) {
      showError();
    }
  });

  // Handle form submission
  form.addEventListener('submit', function(e) {
    const value = input.value.trim();
    
    if (!isValidEmail(value)) {
      e.preventDefault();
      showError();
      input.focus();
      return false;
    }
  });

  // Allow Enter key to submit
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      form.dispatchEvent(new Event('submit'));
    }
  });
})();

